import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-reports-header',
    templateUrl: './reports-header.component.html',
    styleUrls: ['./reports-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsHeaderComponent implements OnInit {
  permissionModules = [];
  constructor() { }

  ngOnInit() {
    this.permissionModules = JSON.parse(localStorage.getItem('permissionModules'));
  }

}
